import http from '@/http'
const URL = '/admin/video-comments'
const SETTINGS_URL = '/admin/settings'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const updateStatus = (id, status) => http.put(URL + `/${id}/status`, { status })

export const destroy = async (id) => http.delete(URL + `/${id}`)

export const updateModeration = (settingId, value) => http.post(SETTINGS_URL + `/${settingId}`, { video_comments_moderation: value })

export default {
  list,
  updateStatus,
  destroy,
  updateModeration
}
